var _metadata, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 16 16",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "Made with Pixels to Svg https://codepen.io/shshaw/pen/XbxvNj")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(0,0,0,0.047058823529411764)",
    d: "M2 0h1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(0,0,0,0.011764705882352941)",
    d: "M3 0h1M5 0h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(0,0,0,0.023529411764705882)",
    d: "M2 1h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(0,0,0,0.01568627450980392)",
    d: "M5 1h1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(0,0,0,0.0196078431372549)",
    d: "M3 2h1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(0,0,0,0.027450980392156862)",
    d: "M4 2h1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(0,0,0,0.9686274509803922)",
    d: "M1 8h1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M1 9h1M1 10h3M1 11h1M3 11h1M1 12h1M3 12h1M1 13h3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#020202",
    d: "M3 14h1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(0,0,0,0.9725490196078431)",
    d: "M3 15h1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNat);
export default __webpack_public_path__ + "static/media/nat.d6abd1f070ee60bc88e28e20f489c4f3.svg";
export { ForwardRef as ReactComponent };